import config from 'config'
import {BRANDS, BRAND_PARTNERS} from 'const'

const REACT_APP_PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || ''

const assetsUrl = `${REACT_APP_PUBLIC_URL}/assets/`

export function mapLogos(logos) {
  return logos.map(logo => Object({src: `${assetsUrl}${logo}`}))
}

export function getIcon(icon) {
  return {
    height: '20px',
    portraitHeight: '30px',
    landscapeHeight: '30px',
    desktopHeight: '32px',
    ...icon,
  }
}

export function getDefaultConfig() {
  return {
    thirdParty: false,
    admeiraOptInOnePager: false,
    emailOnlyRegister: false,
    marketingConsent: false,
    marketingOnePager: false,
    newsletterOnePager: false,
    onePager: false,
    separatorLanding: false,
    subtitleRegister: false,
    subtitleWithFAQLanding: false,
    swissIdLanding: true,
    newsletterConsent: false,
    showRingierBanner: true,
    useCircularSocialLogin: false,
    showProgressBar: false,
  }
}

const FOOTER_LOGOS = {
  [BRANDS.baz]: {
    icon: `${config.url}/assets/brands/baz/footer-logo.svg`,
    footerHeight: '24px',
    ringierSectionHeight: '24px',
  },
  [BRANDS.beobachter]: {
    icon: `${config.url}/assets/logo-beobachter-lightgrey.svg`,
    footerHeight: '16px',
    ringierSectionHeight: '16px',
  },
  [BRANDS.berneroberlander]: {
    icon: `${config.url}/assets/brands/berneroberlander/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.bernerzeitung]: {
    icon: `${config.url}/assets/brands/bernerzeitung/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.bilan]: {
    icon: `${config.url}/assets/brands/bilan/footer-logo.svg`,
    footerHeight: '28px',
    ringierSectionHeight: '28px',
  },
  [BRAND_PARTNERS.bilanz]: {
    icon: `${config.url}/assets/logo-bilanz-lightgrey.svg`,
    footerHeight: '10px',
    ringierSectionHeight: '10px',
  },
  [BRANDS.blick]: {
    icon: `${config.url}/assets/brands/blick/footer-logo.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [BRANDS.derbund]: {
    icon: `${config.url}/assets/brands/derbund/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.derlandbote]: {
    icon: `${config.url}/assets/brands/derlandbote/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.energy]: {
    icon: `${config.url}/assets/logo-radionrj-lightgrey.svg`,
    footerHeight: '36px',
    ringierSectionHeight: '36px',
  },
  [BRANDS.finanzundwirtschaft]: {
    icon: `${config.url}/assets/brands/finanzundwirtschaft/footer-logo.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [BRANDS.illustre]: {
    icon: `${config.url}/assets/logo-illustre-grey.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [BRANDS.interview]: {
    icon: `${config.url}/assets/brands/interview/footer-logo.svg`,
    footerHeight: '16px',
    ringierSectionHeight: '16px',
  },
  [BRANDS.langenthalertagblatt]: {
    icon: `${config.url}/assets/brands/langenthalertagblatt/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.lessentiel]: {
    icon: `${config.url}/assets/brands/lessentiel/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.lematin]: {
    icon: `${config.url}/assets/logo-lematin-grey.svg`,
    footerHeight: '14px',
    ringierSectionHeight: '14px',
  },
  [BRANDS.lematindimanche]: {
    icon: `${config.url}/assets/brands/lematindimanche/footer-logo.svg`,
    footerHeight: '24px',
    ringierSectionHeight: '24px',
  },
  [BRANDS.moonandstars]: {
    icon: `${config.url}/assets/logo-moonstars-grey.svg`,
    footerHeight: '12px',
    ringierSectionHeight: '12px',
  },
  [BRANDS.pme]: {
    icon: `${config.url}/assets/logo-pme-grey.svg`,
    footerHeight: '16px',
    ringierSectionHeight: '16px',
  },
  [BRANDS.rockit]: {
    icon: `${config.url}/assets/logo-rockit-new-grey.svg`,
    footerHeight: '24px',
    ringierSectionHeight: '24px',
  },
  [BRANDS.schlager]: {
    icon: `${config.url}/assets/logo-schlager-grey.svg`,
    footerHeight: '24px',
    ringierSectionHeight: '24px',
  },
  [BRANDS.schweizerfamilie]: {
    icon: `${config.url}/assets/brands/schweizerfamilie/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.schweizerillustrierte]: {
    icon: `${config.url}/assets/brands/schweizerillustrierte/footer-logo.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [`${BRANDS.schweizerillustrierte}-alpha`]: {
    icon: `${config.url}/assets/brands/schweizerillustrierte/footer-logo-alpha.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [BRANDS.sihltaler]: {
    icon: `${config.url}/assets/brands/sihltaler/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.sonntagszeitung]: {
    icon: `${config.url}/assets/brands/sonntagszeitung/footer-logo.svg`,
    footerHeight: '24px',
    ringierSectionHeight: '24px',
  },
  [BRANDS.srg]: {
    icon: `${config.url}/assets/brands/srg/footer-logo.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [BRANDS.tagesanzeiger]: {
    icon: `${config.url}/assets/brands/tagesanzeiger/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.tamedia]: {
    icon: `${config.url}/assets/brands/tamedia/footer-logo.svg`,
    footerHeight: '28px',
    ringierSectionHeight: '28px',
  },
  [BRANDS.thalwileranzeiger]: {
    icon: `${config.url}/assets/brands/thalwileranzeiger/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.thunertagblatt]: {
    icon: `${config.url}/assets/brands/thunertagblatt/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.tribunedegeneve]: {
    icon: `${config.url}/assets/brands/tribunedegeneve/footer-logo.svg`,
    footerHeight: '28px',
    ringierSectionHeight: '28px',
  },
  [BRANDS.twentyfourhours]: {
    icon: `${config.url}/assets/brands/24hours/footer-logo.svg`,
    footerHeight: '28px',
    ringierSectionHeight: '28px',
  },
  [BRANDS.twentymin]: {
    icon: `${config.url}/assets/logo-20min-grey.svg`,
    iconByLang: {fr: `${config.url}/assets/logo-20min-fr-grey.svg`},
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.vintage]: {
    icon: `${config.url}/assets/logo-vintage-grey-2.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [BRANDS.wirtschaftsmedien]: {
    icon: `${config.url}/assets/logo-hz-lightgrey.svg`,
    footerHeight: '18px',
    ringierSectionHeight: '18px',
  },
  [BRANDS.zurcherunterlander]: {
    icon: `${config.url}/assets/brands/zurcherunterlander/footer-logo.svg`,
    footerHeight: '28px',
    ringierSectionHeight: '28px',
  },
  [BRANDS.zurichseezeitung]: {
    icon: `${config.url}/assets/brands/zurichseezeitung/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.cash]: {
    icon: `${config.url}/assets/brands/cash/footer-logo.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [BRANDS.jobs]: {
    icon: `${config.url}/assets/brands/jobs/footer-logo.svg`,
    footerHeight: '14px',
    ringierSectionHeight: '14px',
  },
  [BRANDS.jobup]: {
    icon: `${config.url}/assets/brands/jobup/footer-logo.svg`,
    footerHeight: '14px',
    ringierSectionHeight: '14px',
  },
  [BRANDS.caminada]: {
    icon: `${config.url}/assets/brands/caminada/footer-logo.svg`,
    footerHeight: '24px',
    ringierSectionHeight: '24px',
  },
  [BRANDS.glueckspost]: {
    icon: `${config.url}/assets/brands/glueckspost/footer-logo.svg`,
    footerHeight: '32px',
    ringierSectionHeight: '32px',
  },
  [BRANDS.programmzeitschriften]: {
    icon: `${config.url}/assets/brands/programmzeitschriften/footer-logo.svg`,
    footerHeight: '22px',
    ringierSectionHeight: '22px',
  },
  [BRANDS.landliebe]: {
    icon: `${config.url}/assets/brands/landliebe/footer-logo.svg`,
    footerHeight: '14px',
    ringierSectionHeight: '14px',
  },
  [BRANDS.zff]: {
    icon: `${config.url}/assets/brands/zff/footer-logo.svg`,
    footerHeight: '18px',
    ringierSectionHeight: '18px',
  },
  [BRANDS.nzz]: {
    icon: `${config.url}/assets/brands/nzz/footer-logo.svg`,
    footerHeight: '14px',
    ringierSectionHeight: '14px',
  },
  [BRANDS.nzzmagazin]: {
    icon: `${config.url}/assets/brands/nzzmagazin/footer-logo.svg`,
    footerHeight: '14px',
    ringierSectionHeight: '14px',
  },
  [BRAND_PARTNERS.handelszeitung]: {
    icon: `${config.url}/assets/brands/handelszeitung/footer-logo.svg`,
    footerHeight: '8px',
    ringierSectionHeight: '8px',
  },
  [BRANDS.aargauerzeitung]: {
    icon: `${config.url}/assets/brands/aargauerzeitung/footer-logo.svg`,
    footerHeight: '22px',
    ringierSectionHeight: '22px',
  },
  [BRANDS.jobscout24]: {
    icon: `${config.url}/assets/brands/jobscout24/footer-logo.svg`,
    footerHeight: '24px',
    ringierSectionHeight: '24px',
  },
  [BRANDS.jobbern]: {
    icon: `${config.url}/assets/brands/jobbern/footer-logo.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [BRANDS.ostjob]: {
    icon: `${config.url}/assets/brands/ostjob/footer-logo.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [BRANDS.zentraljob]: {
    icon: `${config.url}/assets/brands/zentraljob/footer-logo.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
  [BRANDS.autodesjahres]: {
    icon: `${config.url}/assets/brands/autodesjahres/footer-logo.svg`,
    iconByLang: {
      fr: `${config.url}/assets/brands/autodesjahres/footer-logo-fr.svg`,
      it: `${config.url}/assets/brands/autodesjahres/footer-logo-it.svg`,
    },
    footerHeight: '24px',
    ringierSectionHeight: '24px',
  },
  [BRANDS.watson]: {
    icon: `${config.url}/assets/brands/watson/footer-logo.svg`,
    footerHeight: '20px',
    ringierSectionHeight: '20px',
  },
}

export function getFooterLogosByBrandList(brands) {
  return brands.map(brand => (typeof brand === 'string' ? FOOTER_LOGOS[brand] || {} : brand))
}

export const getFavicon = brandName => `${config.url}/assets/brands/${brandName}/favicon.ico`

export const getHeaderLogo = brandName => `brands/${brandName}/logo.svg`
